import { PerformanceMetric, usePerformance } from '@/context/performance';
import { setChildAppLoaded } from '@customerio/hydra-nav-state';
import { useEffect, useRef, useState } from 'react';
import { AppBundle } from '../utils/app-bundles';
import { PageLoader } from '@customerio/pluma-components/react';
import { AppBundleLoader } from '@/components/app-bundle-loader';
import { isBackgroundAppBundlesEnabled } from '@/context/background-app-bundle';

export default function Pipelines(props?: { basename?: string }) {
  if (isBackgroundAppBundlesEnabled()) {
    return <PipelinesBackgroundApp basename={props?.basename} />;
  }

  return <PipelinesNonBackgroundApp basename={props?.basename} />;
}

export function PipelinesNonBackgroundApp(props?: { basename?: string }) {
  const ref = useRef(null);
  const rendered = useRef(false);
  const root = useRef<any | null>(null);
  const [loaded, setIsLoaded] = useState(false);
  const recordPerformanceMetric = usePerformance();

  useEffect(() => {
    setChildAppLoaded(false);
  }, []);

  useEffect(() => {
    const load = async () => {
      recordPerformanceMetric(PerformanceMetric.ChildAppLoadStart);
      const { rootComponent: PipelinesApp, ReactDOMClient: PipelinesReactDomClient } = (await window.importShim(
        AppBundle.Pipelines,
      )) as any;
      setIsLoaded(true);

      if (root.current == null) {
        root.current = PipelinesReactDomClient.createRoot(ref.current, { identifierPrefix: 'cdp_' });
      }

      if (!rendered.current && root.current != null) {
        root.current.render(<PipelinesApp basename={props?.basename} useNewWorkspacesUrls={props?.basename == null} />);
        rendered.current = true;
      }
    };

    load();

    return () => {
      if (rendered.current != null) {
        root.current?.unmount();
        rendered.current = false;
        root.current = null;
        setIsLoaded(false);
      }
    };
  }, []);

  return (
    <>
      <div ref={ref} style={{ display: loaded ? 'flex' : 'none', minWidth: 0, flex: 1 }}></div>
      {loaded ? null : <PageLoader />}
    </>
  );
}

export function PipelinesBackgroundApp(props?: { basename?: string }) {
  const rendered = useRef(false);
  const root = useRef<any | null>(null);
  const renderPipelinesApp = async (appWrapper: HTMLDivElement) => {
    const { rootComponent: PipelinesApp, ReactDOMClient: PipelinesReactDomClient } = (await window.importShim(
      AppBundle.Pipelines,
    )) as any;

    if (root.current == null) {
      root.current = PipelinesReactDomClient.createRoot(appWrapper, { identifierPrefix: 'cdp_' });
    }

    if (!rendered.current && root.current != null) {
      root.current.render(<PipelinesApp basename={props?.basename} useNewWorkspacesUrls={props?.basename == null} />);
      rendered.current = true;
    }

    return () => {
      if (rendered.current != null) {
        root.current?.unmount();
        root.current = null;
        rendered.current = false;
      }
    };
  };

  return <AppBundleLoader appBundle={AppBundle.Pipelines} className="pipelines-app" renderApp={renderPipelinesApp} />;
}
